import type { ReactElement } from 'react'

import * as styles from './selectable-list-item-icon.styles'

type Props = {
  children: ReactElement
}

export const SelectableListItemIcon = ({ children }: Props) => (
  <span css={styles.icon} data-testid="selectable-list-item-icon">
    {children}
  </span>
)
